import { Check, Users } from "lucide-react";

// Simple multi-select checkbox list for assigning technicians to a job.
// Up to 6 employees, so an inline list is the clearest UX (no dropdown needed).
export default function TechMultiSelect({ techs = [], value = [], onChange, testid = "tech-multi-select" }) {
  const selected = value || [];
  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else onChange([...selected, id]);
  };
  const names = techs.filter((t) => selected.includes(t.id)).map((t) => t.name);

  return (
    <div data-testid={testid} className="mt-1 border border-slate-200 rounded-lg p-2 space-y-1">
      {techs.length === 0 && <p className="text-xs text-slate-400 px-1 py-1.5">No technicians available.</p>}
      {techs.map((t) => {
        const on = selected.includes(t.id);
        return (
          <button
            key={t.id}
            type="button"
            data-testid={`${testid}-option-${t.id}`}
            onClick={() => toggle(t.id)}
            className={`w-full flex items-center gap-2.5 rounded-md px-2 py-2 text-sm transition-colors text-left ${on ? "bg-navy/5 text-navy" : "hover:bg-slate-50 text-slate-600"}`}
          >
            <span className={`w-4 h-4 rounded border flex items-center justify-center shrink-0 ${on ? "bg-navy border-navy" : "border-slate-300 bg-white"}`}>
              {on && <Check className="w-3 h-3 text-white" />}
            </span>
            {t.name}
            {t.role === "contractor" && <span className="ml-1 text-[10px] font-semibold uppercase tracking-wide text-orange-600 bg-orange-100 rounded px-1.5 py-0.5">Contractor</span>}
          </button>
        );
      })}
      {names.length > 0 && (
        <p className="text-[11px] text-slate-400 px-1 pt-1 flex items-center gap-1">
          <Users className="w-3 h-3" />{names.length} assigned: {names.join(", ")}
        </p>
      )}
    </div>
  );
}
